import { cn } from "@patient-watch/ui";
import { Badge } from "@patient-watch/ui/badge";

const roleVariantMap: Record<string, "default" | "outline" | "secondary" | "destructive"> = {
    PATIENT: "default",
    CLINICIAN: "outline",
    SECRETARY: "secondary",
    ADMIN: "default",
    MANAGER: "secondary",
};

/** Organisation role as a badge. Admin stands out in indigo; other roles use the badge variants. */
export function RoleBadge({ role, label }: { role: string; label: string }) {
    const isAdmin = role === "ADMIN";
    return (
        <Badge
            variant={isAdmin ? "static" : roleVariantMap[role] || "secondary"}
            className={cn(
                "text-2xs shrink-0",
                isAdmin &&
                    "border-transparent bg-indigo-800 text-white hover:bg-indigo-800 dark:bg-indigo-800 dark:text-white"
            )}
        >
            {label}
        </Badge>
    );
}
